export default "__VITE_ASSET__CtjAAeBB__"